import { defineStore } from "pinia";

export const useAlertStore = defineStore("alert", {
  state: () => ({
    message: "",
    type: "",
    timeout: 3000,
    snackbar: false,
  }),
  actions: {
    setAlert(message, type, timeout = 3000) {
      this.message = message;
      this.type = type;
      this.timeout = timeout;
      this.snackbar = true;
    },
    success(message, timeout = 3000) {
      this.setAlert(message, "success", timeout);
    },
    error(message, timeout = 3000) {
      this.setAlert(message, "error", timeout);
    },
    warning(message, timeout = 3000) {
      this.setAlert(message, "warning", timeout);
    },
    info(message, timeout = 3000) {
      this.setAlert(message, "info", timeout);
    },
    clearAlert() {
      this.message = "";
      this.type = "";
      this.snackbar = false;
    },
  },
});
